import React,{Fragment} from "react";
import  { withStyles, withTheme } from '@material-ui/core/styles';
import Arrow from "@material-ui/icons/TrendingFlat";
import { compose } from "recompose";

const styles = theme => ({
   container:{
       display: "flex",
       padding: 0 ,
       width:"calc(100% - 16px)",
       '&:hover $filterIcon':{
             visibility:"visible",
             color: theme.iconColor,
       },
       '& $filterIcon:hover':{
            color: theme.HeaderSelectedText,
       }
   },
   customHeader:{
    paddingLeft: 8,
    display: "flex",
    width: "calc(100% - 16px)",
    cursor: "pointer",
   },
   headerIcons:{
    color: theme.HeaderSelectedText,
    width: 16,
    paddingTop:2,
    '&$filterIcon$filterActive':{
        color: theme.HeaderSelectedText,
     }
   },
   filterIcon:{
       visibility:"hidden",
       cursor: "pointer",
       color: theme.HeaderSelectedText,
       padding:"4px 0px 0px 4px"

   },
   filterActive:{
        visibility:"visible",
        color: theme.HeaderSelectedText,
   },
   iconClass:{
       color: theme.HeaderSelectedText
   },
   sortAsc:{
        transform: "rotate(270deg)"
   },
   sortDesc:{
        transform: "rotate(90deg)"
   },
   headerText:{
       cursor:"pointer"
   }
  });

class HeaderRenderer extends React.Component{
    constructor(props) {
        super(props);
        this.sortOptions = [null,'asc','desc'];
        this.isHeaderDragged = false;
        this.state = {
            activeSortOption: 0,
            filterActive: null
        }

        this.container = this.props.reactContainer;
    }

    componentDidMount() {
        this.onSortChanged();
        this.onFilterChanged();
        this.props.column.addEventListener('sortChanged', this.onSortChanged);
        this.props.column.addEventListener('filterChanged', this.onFilterChanged);
    }
    componentWillUnmount() {
        this.props.column.removeEventListener('sortChanged', this.onSortChanged);
        this.props.column.removeEventListener('filterChanged', this.onFilterChanged);
    }

    onMenuClicked = () => {
        this.props.showColumnMenu(this.menuButton);
    }

    onSortChanged = () => {
        let activeSortOption = this.props.column.isSortAscending() ? 1 : this.props.column.isSortDescending() ? 2 :0;
        this.setState({
          activeSortOption
        });
    }

    onFilterChanged = () => {
        this.setState({
            filterActive: this.props.column.isFilterActive(),
        })
    }

    onSortRequested = ( event) => {
        if(this.isHeaderDragged){
            this.isHeaderDragged = false;
        } else {
            const sortOption = (this.state.activeSortOption + 1) % this.sortOptions.length;
            this.props.setSort(this.sortOptions[sortOption], event.shiftKey);
        }
    }

    onMouseLeave =(event) => {
        const themeClass = `theme-${this.props.theme.themeName}`;
        Array.from(document.getElementsByClassName("ag-dnd-ghost")).forEach(ele => {
            if(!ele.classList.contains(themeClass)){
                ele.classList.add(themeClass);
                ele.classList.add(`columnMoveGhost`);
                this.isHeaderDragged = true;
            }
        });
    }

    render() {
        this.props.reactContainer.className = this.props.classes.container;
        if(this.container.parentElement){
            this.state.activeSortOption ?
            this.container.parentElement.classList.add("sortedColumn")
            :this.container.parentElement.classList.remove("sortedColumn")
        }

        const { classes } = this.props;
        let menu = null;
        if (this.props.enableMenu) {
            menu = this.state.filterActive ?
             <i className="icon-filter"/> : <i className="icon-icon_filter"/>
        }

        let sort = null;
        if (this.props.enableSorting && this.state.activeSortOption) {
            const sortClass = this.state.activeSortOption === 1? classes.sortAsc : classes.sortDesc;
            sort = <Arrow classes={{root: sortClass }}/>
        }

        return (
            <Fragment>
            <div className={classes.customHeader}
                onMouseLeave={this.onMouseLeave}
                onClick={this.props.enableSorting ? this.onSortRequested : () => {}}
            >
                <div className={classes.headerIcons}>
                    {sort}
                </div>
                <div className={classes.headerText}>{this.props.displayName}</div>
            </div>
            {
                this.props.enableMenu &&
                <div ref={(menuButton) => { this.menuButton = menuButton; }}
                     className={`${classes.headerIcons} ${classes.filterIcon} ${this.state.filterActive ? classes.filterActive : ""} filterIcon`}
                     onClick={this.onMenuClicked}>
                    {menu}
                </div>
            }
             </Fragment>
        );
    }

}

export default compose(withStyles(styles),withTheme())(HeaderRenderer);